import { useContext, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppUserContext from "../../context/app-user-context";
import UserImage from "./UserImage";
import ROLE, { getRoleLabel } from "../../modules/role";
import { socket } from "../../socket";
import { PortalContext } from "../../context/portal-context";
import ApiMessage from "../../modules/api/message";
import Config from "../../config/config";

export type TUserHeroProps = {
  hide?: boolean;
};

export default function UserHero(props: TUserHeroProps) {
  const user = useContext(AppUserContext);
  const { setNotifCount, reportUserName, customText } = useContext(PortalContext);
  const location = useLocation();

  const setUnreadCount = (studentId) => {
    ApiMessage.getNotificationsUnreadCount(studentId).then((unreadCount) => {
      if (unreadCount > 0) {
        setNotifCount(unreadCount);
      }
    });
  };

  useEffect(() => {
    if (!Config.ENABLE_SOCKET_NOTIFICATION) {
      return;
    }

    if (!setNotifCount) return;

    if (user.logged) {
      socket.connect();

      const studentId = user.referenceUserId;

      // Listen notification event from server side after connecting
      socket.on("notification", (data: any) => {
        setUnreadCount(studentId);
      });

      // check first load
      setUnreadCount(studentId);

      // Send user id to server side to identify after connecting
      socket.emit("check-in", studentId);
    }

    return () => {
      socket.off("notification");
      socket.disconnect();
    };
  }, [user.logged]);

  const userDesignation = useMemo(() => {
    const role = getRoleLabel(user.role);
    const jobdesk = user.jobTitle;
    return jobdesk === "" || !jobdesk ? role : `${role} | ${jobdesk}`;
  }, [user]);

  const isWorkplaceLearningReport = location.pathname.includes(
    "/portal/my-group/report/workplace-learning/"
  );

  const userName = useMemo(() => {
    if (user.role === ROLE.STUDENT && typeof user.alias === "string" && user.alias.trim() !== "") {
      return user.alias;
    } else {
      return typeof user.name === "string" && user.name.trim() !== ""
        ? user.name
        : "User";
    }
  }, [user]);

  return (
    !props.hide && (
      <div className="user-hero" data-comp="UserHero">
        <div className="uh__box">
          {/* <div className="uh__img">
            <UserImage width={60} url={user.avatar} />
          </div> */}
          <div className="uh__desc">
            <h1>
              {isWorkplaceLearningReport
                // ? `Workplace Learning Report: ${reportUserName || "-"}`
                ? `Workplace Learning Report`
                : (customText ? "GROW-Pro: " + customText : `Welcome to GROW-Pro, ${userName}`)}
            </h1>
            {/* {isWorkplaceLearningReport && (
              <p>Student ID: 1234567890</p>
            )} */}
            {/* <p>
              {userDesignation}
            </p> */}
          </div>
        </div>
      </div>
    )
  );
}
